module.exports = __webpack_public_path__ + "static/img/btn.086e7a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/btn.png
// module id = xCsW
// module chunks = 0